import { CalendarMonthRounded } from '@mui/icons-material'
import { Box, Chip, Paper, Stack, Typography, useTheme } from '@mui/material'
import React from 'react'
import { EllipseText } from '../../../../sharedComponents/EllipseText'
import { AgencyTag } from '../../../../sharedComponents/AgencyTag'

interface BoardCardProps {
  taxYear: string
  title: string
  amount: string
}

export const KanbanViewCard: React.FC<BoardCardProps> = ({
  taxYear,
  title,
  amount,
}) => {
  const theme = useTheme()

  return (
    <Paper
      component="div"
      sx={{
        p: 1.5,
        borderRadius: 2,
        cursor: 'pointer',
        border: `1px solid ${theme.palette.grey[300]}`,
        boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Stack gap={0.5}>
        <EllipseText
          label={title}
          rootProps={{ variant: 'body1', mb: 1 }}
          labelProps={{ fontSize: '0.9rem', fontWeight: theme.typography.fontWeightBold }}
        />

        <Stack direction="row" alignItems="center" gap={0.8}>
          <CalendarMonthRounded fontSize="small" sx={{ color: 'secondary.light' }} />

          <Typography fontSize="0.75rem" color="secondary.light">
            {taxYear}
          </Typography>
        </Stack>

        <Typography fontSize="0.75rem" color="secondary">
          ${amount}
        </Typography>
      </Stack>
    </Paper>
  )
}
